import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField
} from 'react-admin';

import { t } from 'i18next';

import { CustomBulkActions } from '../CustomBulkActions';
import { CustomListActions } from '../CustomListActions';

export const UnitList = props => (
  <List {...props} bulkActionButtons={<CustomBulkActions />} actions={<CustomListActions />} title={t('units.title_list')}>
    <Datagrid rowClick="edit">
      <TextField source="name" label={t('name')} />
      <NumberField source="coefficientPerKilogram" label={t('units.coefficient_per_kilogram_column')}/>
    </Datagrid>
  </List>
);
